import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(
    private http: HttpClient
  ) { }

  getRegions(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/refaddress/regions`, { withCredentials: true });
  }

  getProvinces(regionId): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/refaddress/provinces?regCode=${regionId}`, { withCredentials: true });
  }

  getCities(provinceId): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/refaddress/cities?provCode=${provinceId}`, { withCredentials: true });
  }

  getBarangays(cityId): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/refaddress/barangays?citymunCode=${cityId}`, { withCredentials: true });
  }
}
